import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { MediumPrimaryButton, MediumButton } from '../../components/Buttons';
import { ModalContainer, ModalBody, ModalHeader, ModalFooter } from '../../components/ModalElements';

const UnsentEmailsModal = ({ sendEmails }) => {
  const history = useHistory();
  const [pendingPath, setPendingPath] = useState('');
  const unblockRef = useRef(null);

  useEffect(() => {
    unblockRef.current = history.block(location => {
      setPendingPath(`${location.pathname}${location.search}`);
      return false;
    });

    return () => {
      unblockRef.current?.();
      unblockRef.current = null;
    };
  }, [history]);

  const navigateToPendingRoute = () => {
    const path = pendingPath;
    unblockRef.current?.();
    unblockRef.current = null;
    if (path) {
      history.push(path);
    }
  };

  return (
    pendingPath !== '' && (
      <ModalContainer dismissHandler={navigateToPendingRoute}>
        <ModalHeader>
          <h3>Emails Not Sent</h3>
        </ModalHeader>
        <ModalBody>
          <h4>
            You have unsent emails. They will not see this collection on their dashboard until you send the emails.
          </h4>
          <h4>Would you like to send emails to the list of people you added?</h4>
        </ModalBody>
        <ModalFooter>
          <MediumPrimaryButton data-qa-hook="UnsentEmailsModalYesButton" onClick={sendEmails}>
            Yes, Send Emails
          </MediumPrimaryButton>
          <MediumButton data-qa-hook="UnsentEmailsModalNoButton" onClick={navigateToPendingRoute}>
            No
          </MediumButton>
        </ModalFooter>
      </ModalContainer>
    )
  );
};

UnsentEmailsModal.propTypes = {
  sendEmails: PropTypes.func.isRequired,
};

export default UnsentEmailsModal;
